import VueMatomo from 'vue-matomo'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(({ vueApp, $router }) => {
  if (import.meta.dev) {
    return
  }

  // @ts-ignore: missing type
  if ($router.currentRoute.query?.token) {
    return
  }

  const config = useRuntimeConfig()

  if (!config.public.MATOMO_HOST || !config.public.MATOMO_SITE_ID) {
    console.error('MATOMO_HOST or MATOMO_SITE_ID is not set. Disabling Matomo.')
    return
  }

  vueApp.use(VueMatomo, {
    host: config.public.MATOMO_HOST,
    siteId: config.public.MATOMO_SITE_ID,

    router: $router,

    enableLinkTracking: true,
    requireConsent: false,
    trackInitialView: true,
  })
})
